import React from 'react'

import { 
    PriceContainerDiv, 
    PriceContainerContentsDiv,
    PriceContentsDiv,
    PriceSectionHeader,
    PriceTypeContainerDiv 
} from '../../Styles/Components/PriceContainerStyles'

import PricingTypeBox from './PricingTypeBox'

function PricingContainer(props){
    let ptData = require('../../Data/pricing_data.json')

    return (
        <PriceContainerDiv id="pricing-section">
            <PriceContainerContentsDiv>
                <PriceContentsDiv>
                    <PriceSectionHeader>Pricing Plans</PriceSectionHeader>
                    <PriceTypeContainerDiv>
                        {Object.keys(ptData).map(key => ptData[key].map(item => (
                            <PricingTypeBox ptTier={item.tier} ptCost={item.cost} ptPerks={item.perks} key={item.tier} />
                        )))}
                    </PriceTypeContainerDiv>
                </PriceContentsDiv>
            </PriceContainerContentsDiv>
        </PriceContainerDiv>
    )
}

export default PricingContainer